export default function AssetInfo({ showSparePool, processedData }) {
    let text = 'assets'
    let historicalText = 'historical records'
    let amountScrapped = 0
    if (!showSparePool) {
        if (processedData.tagCount === 1) {
            text = 'asset'
        }
        if (processedData.tagEvents !== processedData.tagCount) {
            if (processedData.tagEvents - processedData.tagCount === 1) {
                historicalText = 'historical record'
            }
        }
        amountScrapped = processedData.data.filter((e) => e.Disposition === 'Scrapped').length
        if (amountScrapped > 0) {
            text = text + ' and ' + amountScrapped.toString() + ' scrapped '
        }
    } else {
        if (processedData.data.length === 1) {
            text = ' spare pool asset'
        } else {
            text = ' spare pool assets'
        }
    }

    return (
        <div
            style={{
                width: '40%',
                textAlign: 'left',
                paddingLeft: '0px',
            }}
        >
            {!showSparePool
                ? (processedData.tagCount - amountScrapped).toString() + ' '
                : processedData.data.length + ' '}
            {text}
            {!showSparePool &&
                processedData.tagEvents !== processedData.tagCount &&
                ` (${processedData.tagEvents - processedData.tagCount} ${historicalText})`}
            {!showSparePool && processedData.tagEvents !== processedData.tagCount && (
                <div
                    className='k-icon k-i-info'
                    title='Historic asset data associated with the parent UID'
                    style={{
                        fontSize: 'small',
                        color: 'blue',
                        padding: '0px 2px 2px 2px',
                    }}
                />
            )}
        </div>
    )
}
